import React from "react";
import { Form } from "antd";
import { FormInstance } from "antd/lib/form";
import { useSuppliesContext } from "components/ratecard/contextProviders";
import { FormSection } from "components/ratecard/_common";
import SuppliesTable from "./SuppliesTable";
import { ConsumableMaterial, ConsumableMaterialFee } from "services/BillingEngineService/interfaces";

interface Props {
  form: FormInstance;
}

const SuppliesSection: React.FC<Props> = ({ form }) => {
  const { consumableMaterials } = useSuppliesContext();
  const supplies = form.getFieldValue("supplies") || [];
  const consumableMaterialsCompleted = consumableMaterials.map((cm: ConsumableMaterial) => ({
    ...cm,
    fee: supplies.find((cmf: ConsumableMaterialFee) => cmf.materialId === cm.id) || {
      materialId: cm.id,
      unit: "fixed",
    },
  }));

  return (
    <FormSection>
      <Form.List name="supplies">
        {() => {
          return (
            <Form.Item noStyle shouldUpdate>
              <SuppliesTable dataSource={consumableMaterialsCompleted} form={form} />
            </Form.Item>
          );
        }}
      </Form.List>
    </FormSection>
  );
};

export default SuppliesSection;
